import { Badge } from "@mantine/core";
import { IconSnowflake, IconSun } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";

type SeasonBadgeProps = {
	season: "summer" | "winter";
	size?: "sm" | "md" | "lg";
	visibleFrom?: "sm";
};

export function SeasonBadge({
	season,
	size = "sm",
	visibleFrom,
}: SeasonBadgeProps) {
	const { t } = useTranslation();
	const summer = season === "summer";

	return (
		<Badge
			variant="light"
			color={summer ? "playGreen" : "playBlue"}
			size={size}
			tt="uppercase"
			visibleFrom={visibleFrom}
			leftSection={
				summer ? (
					<IconSun size={14} stroke={1.8} />
				) : (
					<IconSnowflake size={14} stroke={1.8} />
				)
			}
		>
			{summer ? t("app.summer") : t("app.winter")}
		</Badge>
	);
}
